/**
 * Pure formatter for the live CONTACT_SUMMARY event's "Details shared" line
 * (Decision #18.1, 2026-07-hubspot-native-handoff.md).
 *
 * The wire event carries only structured fields (name/email/phone) — no
 * pre-formatted string — unlike the restored path, where the backend's own
 * persisted `content` (built by HandoffRelay's `persist_contact_summary`,
 * agent/manager.py) is read directly (see restore-messages.ts). This
 * function is the ONE place the frontend reconstructs that string for the
 * live insert, so it must mirror the backend's format EXACTLY:
 *
 *   content = f"Details shared — {event.name} · {event.email}"
 *   if event.phone: content += f" · {event.phone}"
 *
 * A mismatch here would only ever surface as a cosmetic diff between the
 * live-rendered and restored-after-reload copy for the SAME message — keep
 * this in lockstep with the backend if that format ever changes.
 */
import type { ContactSummary } from '@/types/chat';

// Same shape as `@/types/chat`'s ContactSummary (no narrowing at all) — kept
// as its own name rather than importing ContactSummary directly at call
// sites, since "the fields this formatter needs" and "the receipt payload a
// Message carries" are different concerns that happen to coincide today.
export type ContactSummaryFields = ContactSummary;

export function formatContactSummaryContent(
  summary: ContactSummaryFields
): string {
  let content = `Details shared — ${summary.name} · ${summary.email}`;
  if (summary.phone) {
    content += ` · ${summary.phone}`;
  }
  return content;
}
